/* ===== VANAYA THEME JS ===== */

document.addEventListener('DOMContentLoaded', function () {

  // ---- HEADER SCROLL ----
  const siteTop = document.querySelector('.site-top');
  if (siteTop) {
    window.addEventListener('scroll', () => {
      siteTop.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // ---- MOBILE MENU ----
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.getElementById('mob-nav');
  const mobOverlay = document.getElementById('mob-overlay');
  const mobClose = document.getElementById('mob-close');

  function openMob() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (mobOverlay) mobOverlay.classList.add('is-open');
    if (hamburger) hamburger.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMob() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (mobOverlay) mobOverlay.classList.remove('is-open');
    if (hamburger) hamburger.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMob);
  if (mobClose) mobClose.addEventListener('click', closeMob);
  if (mobOverlay) mobOverlay.addEventListener('click', closeMob);

  // ---- CART DRAWER ----
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartBtns = document.querySelectorAll('.header-cart-btn, .js-open-cart');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartCountEl = document.querySelector('.cart-count');

  function openCart() {
    if (cartDrawer) { cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); document.body.style.overflow = 'hidden'; document.body.classList.add('cart-drawer-open'); }
    fetchCart();
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); document.body.style.overflow = ''; document.body.classList.remove('cart-drawer-open'); }
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---- FETCH & RENDER CART ----
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(() => {});
  }

  function renderCart(cart) {
    const body = document.getElementById('cart-drawer-body');
    const emptyState = document.getElementById('cart-empty-state');
    const totalEl = document.getElementById('cart-drawer-total');
    const countEl = document.getElementById('cart-drawer-count');
    const discountRow = document.getElementById('cart-discount-row');
    const discountAmount = document.getElementById('cart-discount-amount');
    const upsellEl = document.getElementById('cart-upsell');
    if (!body) return;

    // Update count
    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count > 0 ? cart.item_count : '0';
      cart.item_count > 0 ? cartCountEl.classList.add('visible') : cartCountEl.classList.remove('visible');
    }
    if (countEl) countEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      if (emptyState) emptyState.style.display = 'flex';
      if (totalEl) totalEl.textContent = '0,00 €';
      if (discountRow) discountRow.style.display = 'none';
      body.querySelectorAll('.cart-item').forEach(el => el.remove());
      return;
    }

    if (emptyState) emptyState.style.display = 'none';

    // Build items HTML
    let html = '';
    cart.items.forEach(item => {
      const price = (item.final_price / 100).toFixed(2).replace('.', ',');
      const compare = item.compare_at_price || 0;
      const hasCompare = compare > item.final_price;
      const compareStr = hasCompare ? (compare / 100).toFixed(2).replace('.', ',') : null;
      const savedStr = hasCompare ? ((compare - item.final_price) / 100).toFixed(2).replace('.', ',') : null;
      const imgUrl = item.featured_image ? item.featured_image.url : item.image;

      html += `<div class="cart-item" data-key="${item.key}">
        <div class="cart-item__image">${imgUrl ? `<img src="${imgUrl}" alt="${item.title}" loading="lazy">` : ''}</div>
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price-block">
            ${hasCompare ? `<span class="cart-item__compare">${compareStr} €</span>` : ''}
            <span class="cart-item__price">${price} €</span>
          </div>
          ${hasCompare ? `<div class="cart-item__savings">🏷️ Du sparst ${savedStr} €</div>` : ''}
          <div class="cart-item__bottom">
            <div class="cart-item__qty">
              <button class="qty-btn" data-key="${item.key}" data-action="decrease">−</button>
              <span class="qty-num">${item.quantity}</span>
              <button class="qty-btn" data-key="${item.key}" data-action="increase">+</button>
            </div>
            <button class="cart-item__delete" data-key="${item.key}" aria-label="Entfernen">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
            </button>
          </div>
        </div>
      </div>`;
    });

    // Render
    body.querySelectorAll('.cart-item').forEach(el => el.remove());
    body.insertAdjacentHTML('afterbegin', html);

    // Total
    if (totalEl) totalEl.textContent = (cart.total_price / 100).toFixed(2).replace('.', ',') + ' €';

    // Savings from compare_at_price only
    const totalSaved = cart.items.reduce((sum, item) => {
      const cmp = item.compare_at_price || 0;
      return sum + Math.max(0, cmp - item.final_price) * item.quantity;
    }, 0);
    if (discountRow && discountAmount) {
      if (totalSaved > 0) {
        discountRow.style.display = 'flex';
        discountAmount.textContent = '-' + (totalSaved / 100).toFixed(2).replace('.', ',') + ' €';
      } else {
        discountRow.style.display = 'none';
      }
    }

    const checkoutBtn = document.querySelector('.cart-checkout-btn');
    if (checkoutBtn) checkoutBtn.href = '/checkout';

    // Qty handlers
    body.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const key = btn.dataset.key;
        const qtyEl = btn.closest('.cart-item__qty')?.querySelector('.qty-num');
        const cur = qtyEl ? parseInt(qtyEl.textContent) : 1;
        updateCartItem(key, btn.dataset.action === 'increase' ? cur + 1 : Math.max(0, cur - 1));
      });
    });

    body.querySelectorAll('.cart-item__delete').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(r => r.json())
    .then(cart => renderCart(cart))
    .catch(() => {});
  }

  // ---- ADD TO CART (handled inline per product page) ----
  // Global fallback for any form not handled by inline scripts
  const addToCartForms = document.querySelectorAll('[data-add-to-cart-form]:not([data-handled])');
  addToCartForms.forEach(form => {
    form.setAttribute('data-handled', 'true');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('.add-to-cart-btn');
      const variantId = form.querySelector('[name="id"]')?.value;
      const qty = form.querySelector('[name="quantity"]')?.value || 1;
      if (!variantId) return;
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(r => r.json())
      .then(() => {
        if (btn) { btn.disabled = false; btn.innerHTML = '✓ &nbsp; In den Warenkorb'; setTimeout(() => { btn.innerHTML = '🛒 &nbsp; In den Warenkorb'; }, 2000); }
        openCart();
        showToast('✓ Produkt wurde hinzugefügt!');
      })
      .catch(() => { if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; } });
    });
  });

  // ---- FAQ ACCORDION ----
  document.querySelectorAll('.faq-item__question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const answer = item.querySelector('.faq-item__answer');
      const isOpen = item.classList.contains('open');

      document.querySelectorAll('.faq-item').forEach(el => {
        el.classList.remove('open');
        el.querySelector('.faq-item__answer').style.maxHeight = '';
      });

      if (!isOpen) {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // ---- PRODUCT ACCORDION ----
  document.querySelectorAll('.product-accordion-item__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.nextElementSibling;
      const isOpen = content.classList.contains('open');
      document.querySelectorAll('.product-accordion-item__content').forEach(c => c.classList.remove('open'));
      if (!isOpen) content.classList.add('open');
      const icon = btn.querySelector('.accordion-icon');
      if (icon) icon.textContent = isOpen ? '+' : '−';
    });
  });

  // ---- THUMBNAIL GALLERY ----
  const thumbs = document.querySelectorAll('.product-page__thumb');
  const mainImg = document.querySelector('.product-page__main-image img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
    });
  });

  // ---- SCROLL ANIMATIONS ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));

  // ---- TOAST ----
  function showToast(msg) {
    let toast = document.querySelector('.toast');
    if (!toast) { toast = document.createElement('div'); toast.className = 'toast'; document.body.appendChild(toast); }
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  }

  // Init fetch cart count on load
  fetch('/cart.js').then(r => r.json()).then(cart => {
    if (cartCountEl && cart.item_count > 0) { cartCountEl.textContent = cart.item_count; cartCountEl.classList.add('visible'); }
  }).catch(() => {});

});
